import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  currentYear = new Date().getFullYear()

  companyLinks = [
    { labelKey: 'nav.about', route: '/about' },
    { labelKey: 'nav.services', route: '/services' },
    // { labelKey: 'nav.portfolio', route: '/portfolio' },
    { labelKey: 'nav.contact', route: '/contact' },
  ]

  socialLinks = [
    { icon: 'facebook', url: 'https://www.facebook.com/profile.php?id=61580440335334', label: 'Facebook' },
    { icon: 'linkedin', url: 'https://www.linkedin.com/in/sos-corp-844953392/', label: 'LinkedIn' },
    { icon: 'x', url: 'https://x.com/corp_sos', label: 'X' },
    // { icon: 'photo_camera', url: 'https://instagram.com', label: 'Instagram' },
    // { icon: 'code', url: 'https://github.com', label: 'GitHub' },
  ]
}
